import styled from 'styled-components';

// Styles
import { colors } from '../../styles/variables';
import { Row, Col } from '../../styles/align';
import { BtnGroup, Button } from '../../styles/forms';
import { Container } from '../style';

/**
 * Formata o Container da Modal Pix
 *
 * @extends {Container}
 *
 * Herda estilo para formatar o interior do Container
 * @extends {Row}
 * @extends {BtnGroup}
 * @extends {Button}
 * @extends {colors}
 */
export const StylePix = styled(Container)`
  position: relative;
  background-color: ${colors.grey.light};
  padding: 1rem;

  ${Row} {
    text-align: left;
    color: ${colors.grey.darkPrimary};

    p {
      color: ${colors.grey.darkPrimary};
      padding: 2rem 0;
      line-height: 1.5;

      strong {
        font-weight: 700;
        color: ${colors.grey.dark};
      }
    }

    input {
      background: #CCCCCC4F;
      box-shadow: inset -4px 3px 1em #CCC;
    }

    ${Col} {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    img {
      padding-bottom: 50px;
      width: 500px;
    }

    ${BtnGroup} {
      width: 100%;
      justify-content: flex-end;

      ${Button} {
        text-decoration: none;

        &:last-of-type {
          background-color: ${colors.primary};
          color: ${colors.default};
          max-width: 230px;
        }
      }
    }
  }
`;
